module.exports = __webpack_public_path__ + "img/4.093dfe4d.png";